module.exports = __webpack_public_path__ + "img/edit.881c0584.svg";